const getCityName = obj => obj.nome;
const getStateInitials = obj => obj.sigla;
export default { getCityName, getStateInitials };



// WEBPACK FOOTER //
// ./src/api/helpers/IBGE.js